module.exports = __webpack_public_path__ + "img/damage-missing.48277894.png";